<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="elevation-5 mt-4 rounded-lg">
                    <div class="card-title">
                        <v-row>
                            <v-col cols="12" md="6">{{ title!=''?title:$t('GeneralSatisfactionOfHousingProductsAndServices') }}</v-col>
                            <v-col cols="12" md="3">
                                <v-select dense dark v-model="fromYear" :items="availableYears" :label="$t('FromYear')" @change="updateChartData"></v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select dense dark v-model="toYear" :items="availableYears" :label="$t('ToYear')" @change="updateChartData"></v-select>
                            </v-col>
                        </v-row>
                    </div>
                    <v-card-text class="h-500">
                        <line-chart ref="lineChart" :data="filteredChartData" :options="chartOptions" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
    import { Line } from 'vue-chartjs'
    import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale } from 'chart.js'
    import { mapGetters } from 'vuex'

    ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale)

    export default {
        components: {
            LineChart: {
                extends: Line,
                props: ['data', 'options'],
                mounted() {
                    if (this.registry) {
                    if (this.registry.plugins.get('xAxisImages')) {
                        this.unregister(this.registry.plugins.get('xAxisImages'))
                    }
                    if (this.registry.plugins.get('averageLine')) {
                        this.unregister(this.registry.plugins.get('averageLine'))
                        }
                    }
                    //this.renderChart(this.data, this.options)
                },
            }
        },
        props: {
            satisfactionQuartersLabels: {
                type: Array,
                default: () => [],
            },
            satisfactionQuartersPercentages: {
                type: Array,
                default: () => [],
            },
            availableYears: {
                type: Array,
                default: () => [],
            },
            title: {
                type: String,
                default: () => '',
            },
        },
        data() {
            const currentYear = new Date().getFullYear()

            return {
                fromYear: this.availableYears[0],
                toYear: this.availableYears[this.availableYears.length - 1],
                chartData: {
                    labels: this.satisfactionQuartersLabels,
                    datasets: [
                        {
                            label: 'الرضا العام',
                            data: this.satisfactionQuartersPercentages,
                            borderColor: '#00bcd4',
                            backgroundColor: 'rgba(0, 188, 212, 0.2)',
                            pointBackgroundColor: '#00bcd4',
                            tension: 0
                        }
                    ]
                },
                chartOptions: {
                    responsive: true,
                    layout: { padding: { left: 70, right: 70, top: 10, bottom: 10, }, },
                }
            }
        },

        watch: {
            satisfactionQuartersLabels: 'editChartData',
            satisfactionQuartersPercentages: 'editChartData',
        },
        computed: {
            ...mapGetters('user', ['loggedInUser', 'language']),
            isArabicLanguage() {
                return this.language === 'ar'
            },
            filteredChartData() {
                const fromIndex = this.chartData.labels.findIndex(label => label.includes(this.fromYear))
                const toIndex = this.chartData.labels
                    .map((label, index) => ({ label, index }))
                    .filter(item => item.label.includes(this.toYear))
                    .slice(-1)[0]?.index + 1 || this.chartData.labels.length

                return {
                    labels: this.chartData.labels.slice(fromIndex, toIndex),
                    datasets: [
                        {
                            ...this.chartData.datasets[0],
                            data: this.chartData.datasets[0].data.slice(fromIndex, toIndex)
                        }
                    ]
                }
            }

        },
        mounted() {

            this.chartOptions = {
                responsive: true,
                maintainAspectRatio: false,
                rtl: this.isArabicLanguage,
                scales: {
                    x: {
                        reverse: this.isArabicLanguage
                    },
                    y: {
                        beginAtZero: true,
                        max: 100,
                        ticks: {
                            callback: (value) => `${value}%`
                        }
                    }
                },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        rtl: this.isArabicLanguage,
                        callbacks: { label: (tooltipItem) => `${tooltipItem.raw}%` }
                    },
                }
            }
            /**/
        },
        methods: {
            editChartData() {

                this.chartData = {
                    labels: this.satisfactionQuartersLabels,
                    datasets: [
                        {
                            label: 'الرضا العام',
                            data: this.satisfactionQuartersPercentages,
                            borderColor: '#00bcd4',
                            backgroundColor: 'rgba(0, 188, 212, 0.2)',
                            pointBackgroundColor: '#00bcd4',
                            tension: 0.3
                        }
                    ]
                }
            },
            updateChartData() {
                const chart = this.$refs.lineChart.$data._chart

                if (chart) {
                    const fromIndex = this.chartData.labels.findIndex(label => label.includes(this.fromYear))
                    const toIndex = this.chartData.labels
                        .map((label, index) => ({ label, index }))
                        .filter(item => item.label.includes(this.toYear))
                        .slice(-1)[0]?.index + 1 || this.chartData.labels.length

                    chart.data.labels = this.chartData.labels.slice(fromIndex, toIndex)
                    chart.data.datasets[0].data = this.chartData.datasets[0].data.slice(fromIndex, toIndex)

                    chart.update()
                }
            }

        }
    }
</script>

<style scoped>
    /* Add any custom styles here */
    .chartjs-render-monitor {
        max-height: 300px !important; /* Adjust this value as needed */
    }
    .h-500 {max-height:500px}
</style>
